<template>
  <v-row class="mb-1">
    <v-col cols="2" style="max-height: 3.5rem; margin: 0; padding: 0 1px 1px 0">
      <v-tooltip
        bottom
        :open-delay="tooltipDelay"
        :open-on-hover="true"
        :open-on-click="false"
        :open-on-focus="false"
      >
        <template #activator="{ on }">
          <div style="padding: 1px; position: relative" v-on="on">
            <v-btn
              style="border-radius: 12px"
              block
              tile
              depressed
              class="save-btn-glass"
              width="100%"
              height="3.4rem"
              @click="$emit('openSearchItemsDialog')"
            >
              <v-icon class="icon-glass">mdi-magnify</v-icon>
            </v-btn>
            <v-chip
              v-if="keyboardShortcutsEnabled && (showShortcutBadges || showBadgesTemporarily)"
              x-small
              color="white"
              text-color="primary"
              style="position: absolute; bottom: 4px; right: 4px; font-weight: bold; min-width: 20px"
            >
              F
            </v-chip>
          </div>
        </template>
        <span>{{ $t("$vuetify.tooltips.searchItems") }}</span>
      </v-tooltip>
    </v-col>

    <v-col cols="2" style="max-height: 3.5rem; margin: 0; padding: 0 1px 1px 0">
      <v-tooltip
        bottom
        :open-delay="tooltipDelay"
        :open-on-hover="true"
        :open-on-click="false"
        :open-on-focus="false"
      >
        <template #activator="{ on }">
          <div v-on="on">
            <v-btn
              style="border-radius: 12px"
              @click="openDeliveryPayment"
              block
              tile
              depressed
              class="save-btn-glass"
              width="100%"
              height="3.4rem"
              :disabled="items && items.length > 0 ? false : true"
            >
              <v-icon class="icon-glass">mdi-bike</v-icon>
            </v-btn>
          </div>
        </template>
        <span>Plaćanje</span>
      </v-tooltip>
    </v-col>
    <v-col cols="2" style="max-height: 3.5rem; margin: 0; padding: 0 1px 1px 0">
      <v-tooltip
        bottom
        :open-delay="tooltipDelay"
        :open-on-hover="true"
        :open-on-click="false"
        :open-on-focus="false"
      >
        <template #activator="{ on }">
          <div v-on="on">
            <v-btn
              style="border-radius: 12px"
              block
              tile
              depressed
              class="save-btn-glass"
              width="100%"
              height="3.4rem"
              @click="$emit('openReceiptsDialog')"
            >
              <v-icon class="icon-glass">mdi-receipt-text</v-icon>
            </v-btn>
          </div>
        </template>
        <span>{{ $t("$vuetify.tooltips.receiptsDialog") }}</span>
      </v-tooltip>
    </v-col>
    <v-col cols="2" style="max-height: 3.5rem; margin: 0; padding: 0 1px 1px 0">
      <v-tooltip
        bottom
        :open-delay="tooltipDelay"
        :open-on-hover="true"
        :open-on-click="false"
        :open-on-focus="false"
      >
        <template #activator="{ on }">
          <div v-on="on">
            <v-btn
              style="border-radius: 12px"
              block
              tile
              depressed
              class="save-btn-glass"
              width="100%"
              height="3.4rem"
              @click="$emit('openCloseBalanceDialog')"
            >
              <v-icon class="icon-glass">mdi-cash-register</v-icon>
            </v-btn>
          </div>
        </template>
        <span>{{ $t("$vuetify.tooltips.closeBalance") }}</span>
      </v-tooltip>
    </v-col>
    <v-col cols="2" style="max-height: 3.5rem; margin: 0; padding: 0 1px 1px 0">
      <v-tooltip
        bottom
        :open-delay="tooltipDelay"
        :open-on-hover="true"
        :open-on-click="false"
        :open-on-focus="false"
      >
        <template #activator="{ on }">
          <div v-on="on">
            <v-btn
              style="border-radius: 12px"
              :disabled="
                selectedTable.number === 0 && selectedTable.items.length === 0
              "
              block
              tile
              depressed
              class="save-btn-glass"
              width="100%"
              height="3.4rem"
              @click="$emit('openSplitReceiptDialog')"
            >
              <v-icon class="icon-glass">mdi-table-split-cell</v-icon>
            </v-btn>
          </div>
        </template>
        <span>{{ $t("$vuetify.tooltips.splitTable") }}</span>
      </v-tooltip>
    </v-col>
    <v-col cols="2" style="max-height: 3.5rem; margin: 0; padding: 0 1px 1px 0">
      <v-menu
        bottom
        left
        flat
        rounded="false"
        nudge-bottom="60px"
        min-width="200px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            style="border-radius: 12px"
            block
            tile
            depressed
            @click="collapseListGroups()"
            class="save-btn-glass"
            width="100%"
            height="3.4rem"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon class="icon-glass">mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list style="min-width: 100%">
          <v-list-item
            :disabled="selectedTable.id === ''"
            @click="openPinSwitch"
          >
            <v-list-item-title>
              {{ $t("$vuetify.tables.transferTableTitle") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="openReceiptNoteDialog">
            <v-list-item-title>
              {{ $t("$vuetify.tables.receiptNote") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="showWriteInProductDialog">
            <v-list-item-title>
              {{ $t("$vuetify.formDetails.writeInTitle") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="openTableHistory">
            <v-list-item-title> Povijest stolova </v-list-item-title>
          </v-list-item>
          <v-list-item @click="exportTables">
            <v-list-item-title> Export stolova </v-list-item-title>
          </v-list-item>
          <v-list-item class="pl-0 pr-0">
            <v-list-group
              v-model="showPrevs"
              v-if="!showPreviews"
              group="previews"
              @click.stop=""
            >
              <template v-slot:activator>
                <v-list-item class="pl-0" active-class="active-link">
                  <v-list-item-content>
                    <div>Pregled računa</div>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-flex v-for="(preview, i) in previews" :key="i">
                <v-list-item
                  link
                  class="pl-7 ma-0 pa-0 remove_padd"
                  exact
                  @click="openReceiptPreview(preview.value)"
                  active-class="active-link"
                >
                  <v-list-item-content>
                    <div class="pl-0">
                      {{ preview.name }}
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-flex>
            </v-list-group>
          </v-list-item>
          <v-list-item @click="showWriteInProductDialog">
            <v-list-item-title>
              {{ $t("$vuetify.formDetails.writeInTitle") }}
            </v-list-item-title>
          </v-list-item>

          <v-list-item :disabled="noItems" @click="$emit('finishPaymentRep')">
            <v-list-item-title> Reprezentacija </v-list-item-title>
          </v-list-item>

          <!-- <v-list-item
            :disabled="noItems"
            style="min-width: 100%"
            class="pa-0 d-flex"
          > -->
          <!-- <v-menu style="min-width: 100%" bottom right offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn style="border-radius:20px "
                  style="
                  align-items: center;
                  justify-items: start;
                  font-family: font-family: Raleway, sans-serif;
                  font-size: 15px;
                  color: black !important;
                  text-align: start  !important;
                  text-transform: unset !important;
                  "
                  block
                  plain
                  v-bind="attrs"
                  v-on="on"
                  @keypress.enter.stop=""
                >
                  Plaćanje
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  v-for="(delivery, i) in deliveries"
                  :key="i"
                  @click="openDeliveryPayment(delivery.value)"
                  link
                  class="pl-7 ma-0 pa-0 remove_padd"
                  exact
                  active-class="active-link"
                >
                  <v-list-item-title> {{ delivery.name }} </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu> -->

          <!-- <v-list-group
              v-model="showDeliveries"
              style="min-width: 100%"
              group="deliveries"
              @click.stop=""
            >
              <template v-slot:activator>
                <v-list-item
                  :disabled="noItems"
                  style="min-width: 50%"
                  class="pl-0"
                  active-class="active-link"
                >
                  <v-list-item-content>
                    <div>Plaćanje</div>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-flex v-for="(delivery, i) in deliveries" :key="i">
                <v-list-item
                  link
                  class="pl-7 ma-0 pa-0 remove_padd"
                  exact
                  @click="openDeliveryPayment(delivery.value)"
                  active-class="active-link"
                >
                  <v-list-item-content>
                    <div class="pl-0">
                      {{ delivery.name }}
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-flex>
            </v-list-group> -->
          <!-- </v-list-item> -->
          <v-list-item :disabled="noItems" @click="printRecapitulation">
            <v-list-item-title>
              {{ $t("$vuetify.tables.cartRecpitulation") }}
            </v-list-item-title>
          </v-list-item>
          <!-- ZA PREDUJAM SAKRIVENO -->
          <!-- <v-list-item :disabled="!noItems" @click="openAvans">
            <v-list-item-title> Račun za predujam </v-list-item-title>
          </v-list-item>
          <v-list-item :disabled="noItems" @click="openAvansSummary">
            <v-list-item-title> Poveži račun za predujam </v-list-item-title>
          </v-list-item> -->
        </v-list>
      </v-menu>
      <switch-table-by-pin ref="pinSwitch"></switch-table-by-pin>
      <add-receipt-note-dialog
        ref="addReceiptNoteDialog"
      ></add-receipt-note-dialog>
      <table-history ref="tableHistory"></table-history>
      <add-write-in-product
        v-if="writeInProductDialog"
        :currency="currency"
        @addProduct="onAddProduct"
        @close="onDialogClose"
      ></add-write-in-product>
      <delivery-payment-dialog
        ref="deliveryPaymentDialog"
      ></delivery-payment-dialog>
      <avans-dialog ref="avans"></avans-dialog>
      <avans-summary ref="avansSummary"></avans-summary>
    </v-col>
  </v-row>
</template>

<script>
import { df } from '@/plugins/firebase'
import state from '@/state'
import { initPdf } from '@/modules/all-reports/pdf/config.js'
import SwitchTableByPin from '@/modules/cash-register/components/SwitchTableByPin.vue'
import AddReceiptNoteDialog from '@/modules/cash-register/components/dialogs/AddReceiptNoteDialog.vue'
import AddWriteInProduct from '@/modules/cash-register/components/AddWriteInProduct'
import TableHistory from '@/modules/cash-register/components/dialogs/tableHistory/TableHistory.vue'
import DeliveryPaymentDialog from '@/modules/cash-register/components/dialogs/DeliveryPaymentDialog.vue'
import EventBus from '@/plugins/event-bus'
import AvansDialog from '@/modules/cash-register/components/dialogs/avans/AvansDialog.vue'
import AvansSummary from '@/modules/cash-register/components/dialogs/avans/AvansSummary.vue'

export default {
  components: {
    SwitchTableByPin,
    AddReceiptNoteDialog,
    TableHistory,
    AddWriteInProduct,
    DeliveryPaymentDialog,
    AvansDialog,
    AvansSummary
  },
  data: function () {
    return {
      deliveries: [
        { name: 'Wolt', value: 'wolt' },
        { name: 'Glovo', value: 'glovo' },
        { name: 'Bolt', value: 'bolt' }
      ],
      cashRegUsers: [],
      tooltipDelay: 500,
      previews: [
        { name: 'Gotovina', value: 'G' },
        { name: 'Ponuda', value: 'P' },
        { name: 'Transakcijski', value: 'T' },
        { name: 'Virman ', value: 'V' }
      ],
      showPreviews: false,
      writeInProductDialog: false,
      showPrevs: false,
      showDeliveries: false
    }
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    selectedTable: {
      type: Object,
      default: () => {}
    },
    selectedTables: {
      type: Array,
      default: () => []
    },
    receiptNote: {
      type: Object,
      default: () => undefined
    },
    currency: {
      type: String,
      default: ''
    },
    discount: {
      type: Object,
      default: () => {}
    },
    keyboardShortcutsEnabled: {
      type: Boolean,
      default: false
    },
    showShortcutBadges: {
      type: Boolean,
      default: false
    },
    showBadgesTemporarily: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    noItems () {
      return this.items.length === 0
    }

  },
  watch: {

  },
  methods: {
    openAvansSummary () {
      this.$refs.avansSummary.open(null, null, this.items, this.discount)
    },
    openAvans () {
      this.$refs.avans.open()
    },
    collapseListGroups () {
      this.showPrevs = false
      this.showDeliveries = false
    },
    openPinSwitch () {
      this.$refs.pinSwitch.open(this.cashRegUsers, state.getCashRegister(), this.selectedTable)
    },

    openReceiptNoteDialog () {
      this.$refs.addReceiptNoteDialog.open(this.receiptNote, this.selectedTable)
    },

    openTableHistory () {
      this.$refs.tableHistory.open()
    },

    openReceiptPreview (method) {
      if (!this.items || this.items.length === 0) {
        return
      }

      var type = 'R'
      switch (method) {
        case 'G':
          type = 'BO'
          break
        case 'P':
          type = 'P'
          method = 'T'
          break
      }

      if (type === 'R' || type === 'P') {
        EventBus.$emit('preview_receipt_r', method, type)
      } else {
        EventBus.$emit('preview_receipt', method, type)
      }
    },

    openDeliveryPayment () {
      this.$refs.deliveryPaymentDialog.open()
    },

    showWriteInProductDialog () {
      this.writeInProductDialog = true
    },

    onDialogClose () {
      this.writeInProductDialog = false
      this.showDeliveries = false
    },

    onAddProduct (item) {
      this.$emit('addWriteInProduct', item)
    },

    printRecapitulation () {
      this.$emit('printRecapitulation')
    },

    async getCashRegUsers (id) {
      const query = await df.collection(`cash_registers/${id}/users`)
      this.cashRegUsers = []
      query.get().then((snapshot) => {
        snapshot.forEach((doc) => {
          this.cashRegUsers.push(doc.data())
        })
      })
    },

    async exportTables () {
      // Fetch ALL tables from Firebase (not just user's tables)
      try {
        const allTables = []
        const query = df.collection(`location_orders/${state.getPointOfSale().id}/tables`).orderBy('number')
        const snapshot = await query.get()

        snapshot.forEach((doc) => {
          const table = doc.data()
          // Include all tables with items, regardless of user_id
          if (table && table.items && table.items.length > 0) {
            allTables.push(table)
          }
        })

        if (allTables.length === 0) {
          alert('Nema otvorenih stolova za export')
          return
        }

        // Export all tables to PDF
        this.exportAsPdf(allTables)
      } catch (error) {
        console.error('Error fetching tables:', error)
        alert('Greška prilikom učitavanja stolova')
      }
    },

    async exportAsPdf (tablesToExport) {
      try {
        // Initialize PDF
        const doc = await initPdf()
        const company = state.getCurrentCompany()
        const pos = state.getPointOfSale()
        const cashRegister = state.getCashRegister()
        const registerInfo = `Blagajna ${cashRegister.number || 1}`

        // Croatian date format
        const dateFormatter = new Intl.DateTimeFormat('hr-HR', {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric'
        })
        const dateStr = dateFormatter.format(new Date()) + '.'

        // Filter out invalid tables (like "gumb" or tables without proper number)
        const validTables = tablesToExport.filter(table => {
          return table &&
                 table.name !== 'gumb' &&
                 table.number !== undefined &&
                 table.number !== null
        })

        let yPosition = 40

        // Company header
        doc.setFontSize(12)
        doc.setFont('Roboto-Bold', 'bold')
        doc.text(company.name || '', 40, yPosition)
        yPosition += 20
        doc.setFont('Roboto-Regular', 'normal')
        doc.text(pos.name || '', 40, yPosition)
        yPosition += 20
        doc.text(`${company.address || ''}, ${company.zip_code || ''} ${company.city || ''}`, 40, yPosition)
        yPosition += 20
        doc.text(`OIB: ${company.oib || ''}`, 40, yPosition)
        yPosition += 30

        // Title
        doc.setFontSize(16)
        doc.setFont('Roboto-Bold', 'bold')
        doc.text('Otvoreni stolovi', 40, yPosition)
        yPosition += 30

        // Calculate grand total
        let grandTotal = 0
        validTables.forEach(table => {
          if (table.items) {
            table.items.forEach(item => {
              grandTotal += (item.total || 0)
            })
          }
        })

        // For each table
        validTables.forEach((table, tableIndex) => {
          // Check if we need a new page
          if (yPosition > 700) {
            doc.addPage()
            yPosition = 40
          }

          // Table header
          doc.setFontSize(10)
          doc.setFont('Roboto-Bold', 'bold')
          doc.text(dateStr, 40, yPosition)
          yPosition += 15
          doc.text(table.name || 'Stol ' + table.number, 40, yPosition)
          yPosition += 15
          doc.text(registerInfo, 40, yPosition)
          yPosition += 20

          // Build table data
          const tableData = []
          let tableTotal = 0

          if (table.items && table.items.length > 0) {
            table.items.forEach(item => {
              // Parse quantity properly - might be stored as amt in thousandths or as string with comma
              let qty = 0
              if (item.quantity !== undefined && item.quantity !== null && item.quantity !== '') {
                // Convert comma to dot if it's a string
                const qtyStr = String(item.quantity).replace(',', '.')
                qty = Number(qtyStr) || 0
              }
              if (qty === 0 && item.amt) {
                qty = Number(item.amt) / 1000
              }
              const quantity = qty.toFixed(2).replace('.', ',') || '0,00'
              const unitPrice = ((Number(item.unitPrice) || 0) / 100).toFixed(2).replace('.', ',')
              const total = ((Number(item.total) || 0) / 100).toFixed(2).replace('.', ',')
              tableTotal += (Number(item.total) || 0)

              tableData.push([
                item.name || '',
                quantity,
                unitPrice,
                total
              ])
            })
          }

          // Add table subtotal row
          const tableTotalFormatted = (tableTotal / 100).toFixed(2).replace('.', ',')
          tableData.push([
            { content: 'Stol ukupno:', colSpan: 3, styles: { fontStyle: 'bold' } },
            { content: `${tableTotalFormatted} ${this.currency || 'EUR'}`, styles: { fontStyle: 'bold' } }
          ])

          // Draw table using autoTable
          doc.autoTable({
            startY: yPosition,
            head: [[
              { content: 'Artikl', styles: { halign: 'left' } },
              { content: 'Količina', styles: { halign: 'right' } },
              { content: 'Cijena', styles: { halign: 'right' } },
              { content: 'Ukupno', styles: { halign: 'right' } }
            ]],
            body: tableData,
            margin: { left: 40, right: 40 },
            styles: {
              font: 'Roboto-Regular',
              fontSize: 9
            },
            headStyles: {
              fillColor: [224, 224, 224],
              textColor: [0, 0, 0],
              fontStyle: 'bold',
              font: 'Roboto-Bold'
            },
            columnStyles: {
              0: { cellWidth: 'auto', halign: 'left' },
              1: { cellWidth: 80, halign: 'right' },
              2: { cellWidth: 80, halign: 'right' },
              3: { cellWidth: 80, halign: 'right' }
            }
          })

          yPosition = doc.lastAutoTable.finalY + 20
        })

        // Grand total
        if (yPosition > 750) {
          doc.addPage()
          yPosition = 40
        }

        const grandTotalFormatted = (grandTotal / 100).toFixed(2).replace('.', ',')
        doc.autoTable({
          startY: yPosition,
          body: [[
            { content: 'Sveukupno:', colSpan: 3, styles: { fontStyle: 'bold', fillColor: [208, 208, 208] } },
            { content: `${grandTotalFormatted} ${this.currency || 'EUR'}`, styles: { fontStyle: 'bold', fillColor: [208, 208, 208] } }
          ]],
          margin: { left: 40, right: 40 },
          styles: {
            font: 'Roboto-Bold',
            fontSize: 9
          },
          columnStyles: {
            3: { halign: 'right' }
          }
        })

        // Generate filename with timestamp
        const now = new Date()
        const year = now.getFullYear()
        const month = String(now.getMonth() + 1).padStart(2, '0')
        const day = String(now.getDate()).padStart(2, '0')
        const hours = String(now.getHours()).padStart(2, '0')
        const minutes = String(now.getMinutes()).padStart(2, '0')
        const fileName = `Otvoreni stolovi ${year}-${month}-${day} ${hours}-${minutes}.pdf`

        // Save PDF
        doc.save(fileName)
      } catch (error) {
        console.error('Export error:', error)
        alert('Greška prilikom exporta stolova')
      }
    }
  },
  mounted () {
    EventBus.$off('open_receipts')
    EventBus.$on('open_receipts', () => {
      this.$emit('openReceiptsDialog')
    })
  },
  created () {
    this.getCashRegUsers(state.getCashRegister().id)
    this.tooltipDelay = state.getTooltipDelay()

    var type = state.getCashRegister().type
    switch (type) {
      case 'MP':
        this.previews = [{ name: 'Gotovina', value: 'G' },
          { name: 'Virman ', value: 'V' }]
        break
      case 'VP':
        this.previews = [
          { name: 'Transakcijski', value: 'T' },
          { name: 'Ponuda', value: 'P' },
          { name: 'Virman ', value: 'V' }]
        break
      case 'ALL':
        this.previews = [{ name: 'Gotovina', value: 'G' },
          { name: 'Transakcijski', value: 'T' },
          { name: 'Ponuda', value: 'P' },
          { name: 'Virman ', value: 'V' }]
        break
      default:
        this.previews = [
          { name: 'Gotovina', value: 'G' },
          { name: 'Transakcijski', value: 'T' },
          { name: 'Ponuda', value: 'P' },
          { name: 'Virman ', value: 'V' }
        ]
    }
  }
}
</script>

<style scoped>
/* Purple Toolbar/Save Buttons Glass-morphism Styles */
.save-btn-glass {
  background: linear-gradient(135deg, rgba(87, 74, 144, 1) 0%, rgba(106, 77, 174, 1) 50%, rgba(87, 74, 144, 1) 100%) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 4px 12px rgba(87, 74, 144, 0.45) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border-radius: 12px !important;
}

.save-btn-glass:hover:not(:disabled) {
  background: linear-gradient(135deg, rgba(77, 64, 124, 1) 0%, rgba(96, 67, 154, 1) 50%, rgba(77, 64, 124, 1) 100%) !important;
  box-shadow: 0 8px 20px rgba(87, 74, 144, 0.7) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: translateY(-2px) scale(1.02);
}

.save-btn-glass:disabled {
  opacity: 0.6 !important;
  background: linear-gradient(135deg, rgba(97, 84, 164, 0.3) 0%, rgba(126, 87, 194, 0.25) 50%, rgba(97, 84, 164, 0.3) 100%) !important;
  box-shadow: 0 1px 4px rgba(97, 84, 164, 0.1) !important;
}

.save-btn-glass:disabled .icon-glass {
  color: rgba(255, 255, 255, 0.5) !important;
}

.icon-glass {
  color: white !important;
}
</style>
